import { useCallback, useRef, useState } from "react";
import { copyTextToClipboard } from "../lib/copyTextToClipboard";

export type CopyStatus = "idle" | "copied" | "error";

export function useCopyToClipboard() {
  const [status, setStatus] = useState<CopyStatus>("idle");
  const timerRef = useRef(0);

  const reset = useCallback(() => {
    window.clearTimeout(timerRef.current);
    setStatus("idle");
  }, []);

  const copy = useCallback(async (text: string, inputEl?: HTMLInputElement | null) => {
    window.clearTimeout(timerRef.current);
    try {
      await copyTextToClipboard(text);
      if (inputEl) {
        inputEl.focus();
        inputEl.select();
      }
      setStatus("copied");
      timerRef.current = window.setTimeout(() => setStatus("idle"), 2200);
      return true;
    } catch {
      if (inputEl) {
        inputEl.focus();
        inputEl.select();
      }
      setStatus("error");
      timerRef.current = window.setTimeout(() => setStatus("idle"), 3200);
      return false;
    }
  }, []);

  const buttonLabel =
    status === "copied" ? "✓ Скопировано" : status === "error" ? "Не удалось" : "Копировать";

  return {
    copy,
    reset,
    status,
    copied: status === "copied",
    error: status === "error",
    buttonLabel,
  };
}
